import * as styles from "./ParagraphTextArea.module.scss";

import React, { createRef, useEffect, useState } from "react";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";

interface ParagraphTextAreaProps {
	htmlText: string;
	hideFromJumpLinks?: boolean;
}
export const getParagraphTextAreaProps = ({
	field_text: { value },
	field_hide_from_jump_links,
}: Queries.ParagraphTextAreaDataFragment): ParagraphTextAreaProps => ({
	htmlText: value,
	hideFromJumpLinks: field_hide_from_jump_links,
});

export const ParagraphTextArea: React.FC<ParagraphTextAreaProps> = ({
	htmlText,
	hideFromJumpLinks,
}) => {
	const [hasWrapped, setHasWrapped] = useState(false);
	const ref = createRef<HTMLDivElement>();

	useEffect(() => {
		const wrapTables = () => {
			// biome-ignore lint/complexity/noForEach: NodeListOf is not iterable
			ref.current.querySelectorAll("table").forEach((table) => {
				const outerWrapper = document.createElement("div");
				const innerWrapper = document.createElement("div");
				outerWrapper.className = styles.tableouterwrapper;
				innerWrapper.className = styles.tableinnerwrapper;
				table.parentNode.insertBefore(outerWrapper, table);
				outerWrapper.appendChild(innerWrapper);
				innerWrapper.appendChild(table);
				setHasWrapped(true);
			});
		};
		if (!hasWrapped) wrapTables();
	}, [hasWrapped, ref]);

	useEffect(() => {
		if (hideFromJumpLinks) {
			const headers = ref.current.querySelectorAll("h2, h3");
			for (let i = 0; i < headers.length; i++) {
				const header = headers[i];
				header.setAttribute("data-variation", "hideFromJumpLinks");
			}
		}
	}, [hideFromJumpLinks, ref]);

	return (
		<WrappedSection
			sectionColour={Colours.WHITE}
			sectionName="ParagraphTextArea"
		>
			<div className={styles.paragraphtextareainner}>
				<div
					ref={ref}
					className={styles.textarea}
					// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
					dangerouslySetInnerHTML={{
						__html: htmlText,
					}}
				/>
			</div>
		</WrappedSection>
	);
};

export default ParagraphTextArea;
